import { useSEO } from "../hooks/useSEO";

/**
 * SEO component: sets document title, meta description, keywords, canonical URL,
 * and optionally hreflang alternates. Uses seoConfig for defaults when props are omitted.
 *
 * @param {string} [title] - Page title (site name appended automatically)
 * @param {string} [description] - Meta description
 * @param {string} [keywords] - Meta keywords
 * @param {string} [canonicalUrl] - Canonical URL (defaults to current URL)
 * @param {boolean} [hreflang] - If true, inject hreflang alternate links for all supported languages
 */
export function SEO({ title, description, keywords, canonicalUrl, hreflang }) {
  useSEO({
    title,
    description,
    keywords,
    canonicalUrl,
    hreflang,
  });
  return null;
}
